var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0968 20.9033H1.16129C0.522581 20.9033 0 21.4259 0 22.0646C0 22.7033 0.522581 23.2259 1.16129 23.2259H15.0968C15.7355 23.2259 16.2581 22.7033 16.2581 22.0646C16.2581 21.4259 15.7355 20.9033 15.0968 20.9033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8387 13.9355H1.16129C0.522581 13.9355 0 14.4581 0 15.0968C0 15.7355 0.522581 16.2581 1.16129 16.2581H22.8387C23.4774 16.2581 24 15.7355 24 15.0968C24 14.4581 23.4774 13.9355 22.8387 13.9355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.8373 6.96777H16.6437C16.005 6.96777 15.4824 7.49035 15.4824 8.12906C15.4824 8.76777 16.005 9.29035 16.6437 9.29035H22.8373C23.476 9.29035 23.9986 8.76777 23.9986 8.12906C23.9986 7.49035 23.476 6.96777 22.8373 6.96777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.8377 0H18.1925C17.5538 0 17.0312 0.522581 17.0312 1.16129C17.0312 1.8 17.5538 2.32258 18.1925 2.32258H22.8377C23.4764 2.32258 23.999 1.8 23.999 1.16129C23.999 0.522581 23.4764 0 22.8377 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.98697 7.89677C11.7134 6.60387 13.076 4.39742 13.1612 2.76774C13.2154 1.74194 12.8399 1.11871 12.5147 0.778065C12.0231 0.259355 11.3108 0 10.4012 0H9.2902C8.65149 0 8.12891 0.522581 8.12891 1.16129C8.12891 1.8 8.65149 2.32258 9.2902 2.32258L10.8889 2.33419L10.8308 2.76387C10.7147 3.60774 9.76633 5.16 8.59342 6.03871C8.34568 6.22452 8.1831 6.49548 8.14052 6.80516C8.09794 7.11484 8.17536 7.41677 8.36116 7.66452C8.58181 7.95871 8.92245 8.12903 9.2902 8.12903C9.54181 8.12903 9.78181 8.04774 9.98697 7.89677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1.85806 7.89677C3.58452 6.60387 4.9471 4.39742 5.03226 2.76774C5.08645 1.74194 4.71097 1.11871 4.38581 0.778065C3.89419 0.259355 3.18194 0 2.27226 0H1.16129C0.522581 0 0 0.522581 0 1.16129C0 1.8 0.522581 2.32258 1.16129 2.32258L2.76 2.33419L2.70194 2.76387C2.58581 3.60774 1.63742 5.16 0.464516 6.03871C0.216775 6.22452 0.0541938 6.49548 0.0116132 6.80516C-0.0309675 7.11484 0.0464518 7.41677 0.232258 7.66452C0.452903 7.95871 0.793548 8.12903 1.16129 8.12903C1.4129 8.12903 1.6529 8.04774 1.85806 7.89677Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonials);
export default __webpack_public_path__ + "static/media/testimonials.36cb147c12d31634daa2c0726524e496.svg";
export { ForwardRef as ReactComponent };